<ng-container *ngIf="dadosAsc$ | async as data">
  <div class="content section">
    <div class="card-container">
      <div class="card-group">
        <div class="card">

          <div class="card-body">
            <div class="card-title">{{'HOME.lastTrade' | translate}}</div>
            <div class="marginCenter">{{ data.lastPrice | safeCurrency }}</div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="card-title">{{'HOME.bestBid' | translate}}</div>
            <div class="marginCenter">{{ data.bestBid | safeCurrency }}</div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="card-title">{{'HOME.bestAsk' | translate}}</div>
            <div class="marginCenter">{{ data.bestAsk | safeCurrency }}</div>
          </div>
        </div>
      </div>
      <div class="mobile">
        <div dssCard class="container">
          <div class="card-body">
            <div class="card-title">{{'HOME.anpTarget' | translate}} {{moment(data.lastUpdate).toDate() | date:'yyyy'}}
              {{'HOME.anp' | translate}}</div>
            <div class="marginCenterMeta">
              <ng-container *ngIf=" data.goalAnpYear.split(' ') as goalAnpYear ">
                <div>{{goalAnpYear[0]}}<span class="MMeta">{{goalAnpYear[1]}}</span></div>
              </ng-container>
            </div>
          </div>
        </div>
        <div dssCard class="container">
          <div class="row">
            <div class="col-11">
              <span class="card-title">{{'HOME.targetAchievement' | translate}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="marginCenterMetaPC">
                <ng-container *ngIf=" data.goalAnpYTD.split(' ') as goalAnpYTD ">
                  <div class="">{{goalAnpYTD[0]}}<span class="MM">{{goalAnpYTD[1]}}</span></div>
                </ng-container>
              </div>
            </div>
            <div class="col-6">
              <div class=" right c-circular-progress--{{data.goalAnpYTDPct}}"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class=" dateAtt">
                {{'HOME.lastUpdate' | translate}} {{ moment(data.lastUpdate).toDate() | date: "dd/MM/yyyy" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="content section">
    <div class="card-cont">
      <div class="dss-card-mod dss-card-option-feature">
        <section class="marginTitle"><span>{{'HOME.bid' | translate}}</span></section>
        <div class="scrolltable">
          <table class="cbioTable">
            <thead class="cbioTableHeader">
              <tr>
                <th class="column-list"><strong>{{'HOME.order' | translate}}</strong></th>
                <th class="column-list"><strong>{{'HOME.size' | translate}}</strong></th>
                <th class="column-list"><strong>{{'HOME.price' | translate}}</strong></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let oferta of data.bestBids">
                <td class="column-list fontweight100"> {{ oferta.buyRef }}</td>
                <td class="column-list fontweight100"> {{ oferta.quantity | number}}</td>
                <td class="column-list fontweight100"> {{ oferta.price | safeCurrency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="dss-card-mod dss-card-option-feature">
        <section class="marginTitle"><span>{{'HOME.ask' | translate}}</span></section>
        <div class="scrolltable">
          <table class="cbioTable">
            <thead class="cbioTableHeader">
              <tr>
                <th class="column-list"><strong>{{'HOME.order' | translate}}</strong></th>
                <th class="column-list"><strong>{{'HOME.size' | translate}}</strong></th>
                <th class="column-list"><strong>{{'HOME.price' | translate}}</strong></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let oferta of data.bestAsks">
                <td class="column-list fontweight100"> {{ oferta.sellRef }}</td>
                <td class="column-list fontweight100"> {{ oferta.quantity | number}}</td>
                <td class="column-list fontweight100"> {{ oferta.price | safeCurrency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="dss-card-mod-ult dss-card-option-feature">
        <div class="row">
          <div class="col-9"> <span class="tradeRecap trade-recap-margin">{{'HOME.tradeRecap' | translate}}</span></div>
          <div *ngIf="data.dealsDone && data.dealsDone.length > 0" class="col-1">
            {{ moment(data.dealsDone[0].timestamp).toDate() | date: 'dd/MM/yyyy'}} </div>
        </div>
        <div class="scrolltable">
          <table class="cbioTable">
            <thead class="cbioTableHeader">
              <tr>
                <th class="column"><strong>{{'HOME.timestamp' | translate}}</strong></th>
                <th class="bigColumn"><strong>{{'HOME.bidOrder' | translate}}</strong></th>
                <th class="bigColumn"><strong>{{'HOME.askOrder' | translate}}</strong></th>
                <th class="smallColumn"><strong>{{'HOME.bidAskOrder' | translate}}</strong></th>
                <th class="column"><strong>{{'HOME.size' | translate}}</strong></th>
                <th class="column"><strong>{{'HOME.price' | translate}}</strong></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let negociacoes of data.dealsDone">
                <td class="column fontweight100">{{ moment(negociacoes.timestamp).toDate() | date: 'HH:mm:ss'  }}</td>
                <td class="bigColumn fontweight100">{{ negociacoes.buyRef }}</td>
                <td class="bigColumn fontweight100">{{ negociacoes.sellRef }}</td>
                <td class="smallColumn fontweight100">{{ negociacoes.buyRef}}
                  {{ negociacoes.sellRef }}
                </td>
                <td class="column fontweight100">{{ negociacoes.quantity | number : '1.0-0'}}</td>
                <td class="column fontweight100">{{ negociacoes.price | safeCurrency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="content section">
    <div class="card-container">
      <div class="dss-card-footer">
        <picture class="imgBio img-float-left">
          <img class="imgSize logoRenovabio" alt="Falha ao Carregar imagem" />
        </picture>
        <div>
          <h5>{{'HOME.contactUs' | translate}}</h5>
          <p>
            {{'HOME.wouldLike' | translate}}
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class='content section'>
    <div class='loading-container'>
      <p>Carregando dados...</p>
    </div>
  </div>
</ng-template>
